export default __webpack_public_path__ + "static/media/save.ea3e9f83.png";